import { render, staticRenderFns } from "./main-professionalism.vue?vue&type=template&id=e8b3b4c4&scoped=true"
import script from "./main-professionalism.vue?vue&type=script&lang=js"
export * from "./main-professionalism.vue?vue&type=script&lang=js"
import style0 from "./main-professionalism.vue?vue&type=style&index=0&id=e8b3b4c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b3b4c4",
  null
  
)

export default component.exports